/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import {LoginTimeoutPopup} from "../../Auth/LoginTimeoutPopup";
import {SET_SESSION_TIMEOUT} from "../../../Redux/Actions";


export const StreamBankSessionTimeoutCheckerEnhance = ((ComposedComponent) => function StreamBankSessionTimeoutCheckerEnhance(props) {
    const displayTimeout = useSelector(state => state.loginState.displayTimeout);
    const dispatch = useDispatch();
    const pathName = document.location.pathname.toLowerCase();
    const excludedPaths = ['/login', '/forgotpassword'];

    const clearSessionTimeout = () => {
        dispatch({type: SET_SESSION_TIMEOUT, value: false});
    };

    return <div>
        <LoginTimeoutPopup
            display={displayTimeout && !excludedPaths.includes(pathName)}
            successLogic={clearSessionTimeout}
        />
        <ComposedComponent
            {...props}
        />
    </div>;
})
